import startOfToday from 'date-fns/startOfToday';

import { Month } from '../types';
import getDateMonthAndYear from './getDateMonthAndYear';

export default function getCurrentYearMonthAndDate(): Month {
  return getDateMonthAndYear(startOfToday());
}
